import { useStepsNavigation } from '@/pages/auth/hooks/useStepsNavigation';
import type { Step } from '@/pages/auth/sign-up/constants';
import { SIGN_UP_INVITE_FORM_STEP_PATHS } from '@/pages/auth/sign-up/constants';
import { AuthPaths } from '@/shared/lib/react-router';

export const useInviteNavigation = () => {
  return useStepsNavigation<Step>({
    steps: SIGN_UP_INVITE_FORM_STEP_PATHS,
    routerPath: AuthPaths.SIGN_UP_INVITE.STEP,
  });
};
